import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "notification-content" }
const _hoisted_3 = { class: "notification-close" }

import {Notifications} from "@kyvg/vue3-notification";
import Icon from "@/components/UI/Icon.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'Notification',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Notifications), { width: "100%" }, {
    body: _withCtx((props) => [
      _createElementVNode("div", {
        class: _normalizeClass(["vue-notification-template", props.class]),
        onClick: props.close
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(props.item.text), 1),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(Icon, {
            name: "close",
            size: 8
          })
        ])
      ], 10, _hoisted_1)
    ]),
    _: 1
  }))
}
}

})